import { render } from "./XIcon.vue?vue&type=template&id=393f2419&scoped=true"
import script from "./XIcon.vue?vue&type=script&lang=js"
export * from "./XIcon.vue?vue&type=script&lang=js"

import "./XIcon.vue?vue&type=style&index=0&id=393f2419&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393f2419"]])

export default __exports__